const config = {
  development: {
    //API_HOST: "http://192.168.1.47:11002", // 后端本地
    //API_HOST: "http://testcloud.360ivf.com", // 线上测试
    //API_HOST: "http://cloud.360ivf.com", // 线上正式

    //appId: "wx22a1f0da54a37d32", // 王力测试公众号
    //appId: "wx04bfeaa4425042ae", // 水母来了公众号
    //appId: "wxd97304f19a086804" // 试管无忧公众号
   
  },
  production: {
    //API_HOST: "http://192.168.1.47:11002", // 后端本地
    //API_HOST: "http://testcloud.360ivf.com", // 线上测试
    API_HOST: "http://cloud.360ivf.com", // 线上正式

    //appId: "wx04bfeaa4425042ae", // 水母来了公众号
    appId: "wxd97304f19a086804", // 试管无忧公众号

    //HTTP_HOST_SMLL: 'http://testpgy.360ivf.com/#', //水母来了公众号测试域名
    HTTP_HOST_SMLL: 'http://pgy.360ivf.com/#', //水母来了公众号正式域名
    
    //HTTP_HOST_SGWY: 'http://testpgy.sgwy.360ivf.com/#', //试管无忧公众号测试域名
    HTTP_HOST_SGWY: 'http://pgy.sgwy.360ivf.com/#', //试管无忧公众号正式域名
  },
}


export default config[process.env.NODE_ENV]